export const isTrue = (errorsArray: string[]) => {
  return errorsArray.length === 0;
};
